import {
    createExtraResource,
    createProjectCommentCancel,
    createProjectRetrospective,
    createProjectinRed,
    createReasonPauseForProject,
    createSaveUpdateHours,
    deletePauseForProject,
    deleteRequestProject,
    finishProject,
    getRequestUpdateTime,
    putExtraResource,
    putHasCommentProject,
    putProject,
    putUpdateHours,
    setRequestPutHoursExtra,
    setRequestSaveHoursExtra,
    updatePauseForProject,
    updateReasonPauseForProject,
} from "../../../../config";
import { Endpoints } from "../../../../config/type_endpoints";
import { verificationDatePauses } from "../../../../helpers/projectHelper";
import { replaceIdURL } from "../../../../helpers/replaceId";
import { MessageAnt } from "../../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../../types/messageType";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import { typesPauses } from "../../../../types/typePauses";

const updateProjectDetails = async ({ form, extraData: { idSpace } }) => {
    const url = replaceIdURL(Endpoints.updateProject.infoproject, "spaceId", idSpace);
    const { status } = await putProject(url, form);
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo editar");
        return false;
    }
    return true;
};

const updateWorkTeam = async ({ form, extraData: { idSpace } }) => {
    const url = replaceIdURL(Endpoints.updateProject.team, "spaceId", idSpace);
    const { status } = await putProject(url, form);
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo editar equipo");
        return false;
    }
    return true;
};

const updateClients = async ({ form, extraData: { idSpace } }) => {
    const url = replaceIdURL(Endpoints.updateProject.infocliente, "spaceId", idSpace);
    const { status } = await putProject(url, form);
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo editar clientes");
        return false;
    }
    return true;
};

const updateCalendar = async ({ form, extraData }) => {
    const { isPause = false, ...formValue } = form;
    if (isPause) return await updatePauses({ form: formValue, extraData });
    const url = replaceIdURL(Endpoints.updateProject.dates, "spaceId", extraData.idSpace);
    const { status } = await putProject(url, form);
    if (status === 0) return true;

    MessageAnt(MessageType.error, "No se puedo editar el calendario");
    return false;
};

const changueDatePausesByFormatDate = ({ initDate = null, finishDate = null, ...restForm }) => {
    let jsonReturn = {
        ...restForm,
    };
    if (initDate) {
        jsonReturn.initDate = initDate.format("YYYY-MM-DD");
    }
    if (finishDate) {
        jsonReturn.finishDate = finishDate.format("YYYY-MM-DD");
    }
    return jsonReturn;
};

const createPauseInit = async (form) => {
    const { status } = await createReasonPauseForProject(form);
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo agregar la pausa");
        return false;
    }
    return true;
};

const createPauseInitAndFinish = async (form) => {
    const { status } = await createReasonPauseForProject(form);
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo agregar la pausa");
        return false;
    }
    return true;
};

const updateReactivePause = async ({ idPause, spaceId, reasons, finishDate }) => {
    const { status } = await updateReasonPauseForProject(idPause, spaceId, { reasons, finishDate });
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo reactivar el proyecto en pausa");
        return false;
    }
    return true;
};

const updatePauseId = async ({ id, spaceId, initDate, finishDate, reasonsId }) => {
    const { status } = await updatePauseForProject(id, spaceId, { initDate, finishDate, reasonsId });
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo editar el proyecto en pausa");
        return false;
    }
    return true;
};
const deletePause = async ({ id, spaceId }) => {
    const { status } = await deletePauseForProject(id, spaceId);
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo eliminar el proyecto en pausa");
        return false;
    }
    return true;
};

const updatePauses = async ({ form, extraData: { idSpace, start, pauses = [] } }) => {
    const { typePauseSelect, ...formRest } = form;
    const formDates = changueDatePausesByFormatDate(formRest);

    //? pausas para checar si entra en fechas
    const pauseArray = [typesPauses.deletePause, typesPauses.editPause].includes(typePauseSelect)
        ? pauses.filter((p) => p._id !== formRest.id)
        : pauses;

    if (typePauseSelect !== typesPauses.deletePause) {
        const { isCreatePause, msgPause } = verificationDatePauses(formDates, start, pauseArray);
        if (!isCreatePause) {
            MessageAnt(MessageType.warning, msgPause);
            return false;
        }
    }

    formDates.spaceId = idSpace;

    const updateActionPause = {
        [typesPauses.createPause]: createPauseInit,
        [typesPauses.createPauseRange]: createPauseInitAndFinish,
        [typesPauses.reactivePause]: updateReactivePause,
        [typesPauses.editPause]: updatePauseId,
        [typesPauses.deletePause]: deletePause,
    };

    return await updateActionPause[typePauseSelect](formDates);
};

const updateHrsProjectDetails = async ({ form, extraData: { idSpace } }) => {
    const { type = 0, isTracing = false, ...valueForm } = form;
    let urlHrsProjectDetails =
        type === 0
            ? replaceIdURL(Endpoints.updateProject.calculatedHours, "spaceId", idSpace)
            : replaceIdURL(Endpoints.updateProject.budgethours, "spaceId", idSpace);

    if (isTracing) {
        urlHrsProjectDetails += "?isTracing=true";
    }

    const { status } = await putProject(urlHrsProjectDetails, valueForm);
    if (status > 0) {
        MessageAnt(MessageType.error, "No se puedo actualizar las horas");
        return false;
    }
    return true;
};

const updateHrsExtraResource = async ({ form, extraData: { idSpace, nameUser } }) => {
    const { typeEndpoint, comment: commentResource, key, ...formExtraResource } = form;

    formExtraResource.comment = {
        userName: nameUser,
        text: commentResource,
    };

    if (typeEndpoint === 0) {
        formExtraResource.spaceId = idSpace;
        const { status: stsExtraResourceCreate } = await createExtraResource(formExtraResource);
        if (stsExtraResourceCreate > 0) {
            MessageAnt(MessageType.error, "No se puedo crear el recurso extra");
            return false;
        }
    }

    if (typeEndpoint === 1) {
        formExtraResource.resourceId = key;
        const { status } = await putExtraResource(formExtraResource);
        if (status > 0) {
            MessageAnt(MessageType.error, "No se puedo editar el recurso extra");
            return false;
        }
    }

    return true;
};

const updateExtraTime = async ({ form, extraData: { idSpace } }) => {
    const { typeEndpointHrsExtra, idTimeExtra, ...valueForm } = form;
    if (typeEndpointHrsExtra === 0) {
        valueForm.spaceId = idSpace;
        const { status } = await setRequestSaveHoursExtra(valueForm);
        if (status > 0) {
            MessageAnt(MessageType.error, "Fallo la peticion de horas extras");
            return false;
        }
    } else {
        const { status } = await setRequestPutHoursExtra(idTimeExtra, valueForm);
        if (status > 0) {
            MessageAnt(MessageType.error, "Fallo la peticion de horas extras");
            return false;
        }
    }
    return true;
};

const updateFinishedProject = async ({ form, extraData: { idSpace } }) => {
    const [{ status, msg }, { status: staHascomment }] = await Promise.all([finishProject(idSpace, { finishedAt: form }), putHasCommentProject(idSpace, false)]);

    if (staHascomment > 0) {
        MessageAnt(MessageType.error, `Error al cambiar el estatus de concluido}`);
        return false;
    }
    if (status > 0) {
        if (status === 2) {
            MessageAnt(MessageType.error, `Error al guardar las horas en la base: ${msg}`);
            return false;
        }
        MessageAnt(MessageType.error, `No se pudo Concluir`);
        return false;
    }

    MessageAnt(MessageType.success, `Recuerda agregar tus comentarios al concluir`);
    return true;
};

const cancelProyect = async ({ form, extraData: { nameUser, email, idSpace } }) => {
    const [{ status: stsDelete }, { status: stsHasComment }] = await Promise.all([
        deleteRequestProject(idSpace),
        putHasCommentProject(idSpace, true),
    ]);
    if (stsDelete > 0) {
        MessageAnt(MessageType.error, `Error al elimimar ${idSpace}`);
        return false;
    }

    if (stsHasComment > 0) {
        MessageAnt(MessageType.error, `Error al cambiar marcar que finalizo`);
        return false;
    }

    return true;
};

const updateCancelProyect = async ({ form, extraData: { nameUser, email, idSpace } }) => {
    form.personName = nameUser;
    form.email = email;
    form.projectId = idSpace;

    const { status } = await createProjectCommentCancel(form);

    if (status > 0) {
        MessageAnt(MessageType.error, `Error al crear el comentario`);
        return false;
    }

    return true;
};

const updateCommentRetrospective = async ({ form, extraData: { idSpace, nameUser, isProjectRed } }) => {
    const jsonRequest = {
        spaceId: idSpace,
        personName: nameUser,
        commentInformation: form.commentInformation,
    };

    const { status: stsProjectRetrospective } = await createProjectRetrospective(jsonRequest);

    if (stsProjectRetrospective === 1) {
        MessageAnt(MessageType.warning, `El email no se envio`);
    }

    if (stsProjectRetrospective > 1) {
        MessageAnt(MessageType.error, `Error al agregar el retrospective`);
        return false;
    }

    if (!isProjectRed) {
        const { status: staHascomment } = await putHasCommentProject(idSpace);
        if (staHascomment > 0) {
            MessageAnt(MessageType.error, `Error al cambiar el estatus de concluido}`);
            return false;
        }
    }

    return true;
};

const updateProjectRed = async ({ form, extraData: { idSpace } }) => {
    const { isSave, ...formValue } = form;
    if (!isSave) {
        return false;
    }

    formValue.spaceId = idSpace;

    const [{ status }] = await Promise.all([createProjectinRed(formValue), putHasCommentProject(idSpace)]);

    if (status === 1) {
        MessageAnt(MessageType.warning, `No se mando email`);
    }

    if (status > 1) {
        MessageAnt(MessageType.error, `Error al crear project red`);
        return false;
    }

    return true;
};

const updateProjectAdjustmentHrs = async ({ form, extraData: { idSpace, nameUser } }) => {
    const { type = 0, idSelect = -1, comment, ...valueForm } = form;

    valueForm.comment = {
        text: comment,
        userName: nameUser,
    };

    valueForm.spaceId = idSpace;
    if (type === 0) {
        const { status } = await createSaveUpdateHours(valueForm);
        if (status > 0) {
            MessageAnt(MessageType.error, "Error al crear");
            return false;
        }
    } else {
        valueForm.backupId = idSelect;
        const { status } = await putUpdateHours(valueForm);
        if (status > 0) {
            MessageAnt(MessageType.error, "Error al editar");
            return false;
        }
    }

    return true;
};

const updateTimesConcluedProject = async ({ extraData: { idSpace } }) => {
    const { status } = await getRequestUpdateTime(idSpace);
    if (status > 0) {
        MessageAnt(MessageType.error, `error al actualizar tiempos`);
        return false;
    }

    return true;
};


export const handlersUpdateForm = {
    [typeForDetailsProyect.hrsProjectDetails]: updateHrsProjectDetails,
    [typeForDetailsProyect.client]: updateClients,
    [typeForDetailsProyect.calendar]: updateCalendar,
    [typeForDetailsProyect.pauses]: updatePauses,

    [typeForDetailsProyect.hrsExtraResource]: updateHrsExtraResource,
    [typeForDetailsProyect.hrsExtraTime]: updateExtraTime,
    [typeForDetailsProyect.updateHrs]: updateProjectAdjustmentHrs,

    [typeForDetailsProyect.finishProjectDate]: updateFinishedProject,
    [typeForDetailsProyect.concluedProject]: updateCommentRetrospective,
    [typeForDetailsProyect.projectRed]: updateProjectRed,
    [typeForDetailsProyect.updateTimeConclued]: updateTimesConcluedProject,

    [typeForDetailsProyect.cancelarProyect]: cancelProyect,
    [typeForDetailsProyect.continueCancelarProyect]: updateCancelProyect,

    [typeForDetailsProyect.workTeam]: updateWorkTeam,
    [typeForDetailsProyect.projects]: updateProjectDetails,
};


